import { Item as ChequeItem } from '@baemingo/table-events/dist/types';
import { LocalItem } from '~Types';
import { CourseType } from '~reducers';

/**
 * Rounds to two decimals, same as Tables ArticleItem. Summed fractions (combineArticles)
 * otherwise show floating point noise, e.g. 3 x 1/3 = 0.9999999.
 */
export const roundQuantity = (quantity: number) => Math.round(quantity * 100) / 100;

/**
 * Converts an item on a cheque (table-events) to the LocalItem shape used by the carts.
 * Table items store variations as `richVariations` and the course as `courseId`.
 */
export const chequeItemToLocalItem = (
  item: ChequeItem & { count?: number },
  courseTypes: CourseType[],
): LocalItem => ({
  id: item.id,
  itemId: item.itemId,
  categoryId: item.categoryId,
  entryId: item.entryId,
  title: item.title,
  description: '',
  variations: item.richVariations ?? [],
  removedVariations: item.removedVariations ?? [],
  courseType: courseTypes.find((ct) => ct.id === item.courseId),
  message: item.message,
  amount: item.amount,
  discount: item.discount,
  fraction: item.fraction !== undefined ? roundQuantity(item.fraction) : item.fraction,
  vatRate: item.vatRate,
  /** Only set for combined (compressed) rows, the carts check `'count' in item` */
  ...(item.count !== undefined && { count: roundQuantity(item.count) }),
});
